import Big from "big.js";

const toBig = (value) => {
  if (value === null || value === undefined || value === "") {
    return new Big(0);
  }
  return new Big(value);
};

export const toNumber = (value) => Number(toBig(value).toString());

export const add = (a, b) => toNumber(toBig(a).plus(toBig(b)));
export const sub = (a, b) => toNumber(toBig(a).minus(toBig(b)));
export const mul = (a, b) => toNumber(toBig(a).times(toBig(b)));
export const div = (a, b) => toNumber(toBig(a).div(toBig(b)));

/** Round to `dp` decimal places (default 3). */
export const round = (value, dp = 3) => {
  const decimals = Number.isFinite(Number(dp)) ? Number(dp) : 3;
  return toNumber(toBig(value).round(decimals));
};

/** Fixed decimal string for display (default 3 places). */
export const toFixed = (value, dp = 3) => {
  if (value === null || value === undefined || value === "") return "-";
  const decimals = Number.isFinite(Number(dp)) ? Number(dp) : 3;
  try {
    return toBig(value).round(decimals).toFixed(decimals);
  } catch (error) {
    return "-";
  }
};

/** Display helper for Smart RTP money / RTP fields. */
export const formatSmartRtpNumber = (value, dp = 3) => toFixed(value, dp);
